import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Select from 'react-select'
import DataTable from 'react-data-table-component'
import {
  CUSTOM_STYLE_PERMISSION_DATA_TABLE, CONSUMPTION_TYPE,
  PUBLISHED_STATUS_WEB_WAP, PUBLISHED_STATUS_APP
} from '../../../../constants/cms'
import { Link } from 'react-router-dom'
import { RiEdit2Line } from 'react-icons/ri'
import { FiChevronRight } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchPredictorToolsFilterData,
  fetchPredictorToolsListingData,
  getPredictorToolName, getPredictorToolDomain, getPredictorToolType
} from '../../../../../store/actions/cms/predictorTools'
import Loading from '../../../../components/utils/loader'

const ManagePredictor = () => {
  const [toolType, setToolType] = useState(null);
  const [toolName, setToolName] = useState(null);
  const [domain, setDomain] = useState(null);
  const [consumptionType, setConsumptionType] = useState(null);
  const [statusWeb, setStatusWeb] = useState(null);
  const [statusApp, setStatusApp] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCustomData, setTableCustomData] = useState([])
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [totalPublishedRP, setTotalPublishedRP] = useState(0)
  const [debounceState, setDebounceState] = useState("");

  const { listingData, listingLoading, predictorToolTypeData, predictorToolNameData, predictorToolDomainData } = useSelector((state) => state.predictorToolsReducer)

  const dispatch = useDispatch()
  // Fetch filter data
  useEffect(() => {
    dispatch(fetchPredictorToolsFilterData())
    dispatch(getPredictorToolType({ field_name: "tools_type" }))
    dispatch(getPredictorToolDomain({ field_name: "domain" }))
  }, [])

  useEffect(() => {
    if (currentPage) {
      let params = {};
      params.page = currentPage;
      params.page_size = perPage;
      if (toolType?.id) {
        params.tool_type = toolType?.id
      }
      if (toolName?.id) {
        params.tools_name = toolName?.id
      }
      if (domain) {
        params.domain = domain?.id
      }
      if (consumptionType) {
        params.consumption_type = consumptionType?.id
      }
      if (statusWeb) {
        params.published_status_web_wap = statusWeb?.id == 'published' ? "True" : "False"
      }
      if (statusApp) {
        params.published_status_app = statusApp?.id == 'published' ? "published" : "unpublished"
      }
      dispatch(fetchPredictorToolsListingData(params))
      setTableData(listingData?.data?.tools_list?.results || [])
      setTotalRows(listingData?.data?.tools_list?.totalRows)
      setTableCustomData([
        // {
        //   name: 'Id',
        //   selector: (row) => row.id,
        //   cell: (row, index, column, id) => row.id,
        // },
        {
          name: 'Tool Name',
          selector: (row) => row.name,
          cell: (row, index, column, id) => row.name,
          width: '300px',
        },
        {
          name: 'List Price',
          selector: (row) => (row.list_price === null ? 0 : row?.list_price),
          center: "true",
        },
        {
          name: 'Offer Price',
          selector: (row) => (row.offer_price === null ? 0 : row?.offer_price),
          center: "true",
        },
        {
          name: 'Published Status Web/Wap',
          selector: (row) => row.web_wap_status,
          center: "true",
        },
        {
          name: 'Published Status App',
          selector: (row) => row.app_status,
          center: "true",
        },
        {
          name: 'Created',
          selector: (row) => row.created_date,
          center: "true",
          width: '200px',
        },
        {
          name: 'Updated',
          selector: (row) => row.updated_date,
          center: "true",
          width: '200px',
        },
        {
          name: 'Action',
          selector: (row) => row.action,
          cell: (row, index, column, id) => (
            <div>
              <a href={`/cms/tools/manage-predictor/basic-form/${row.id}`}>
                <span className={'icon_edit'}>
                  <RiEdit2Line />
                </span>
              </a>
            </div>
          ),
          allowOverflow: true,
          center: 'true',
        },
      ])
    }
  }, [currentPage]);

  // Update table data when listingData changes
  useEffect(() => {
    if (listingData) {
      setTableData(listingData?.data?.tools_list?.results || [])
      setTotalPublishedRP(
        listingData?.data?.total_published_result_predictor || 0
      )
      setTotalRows(listingData?.data?.tools_list?.totalRows)
    }
  }, [listingData])

  // handles the change of page by DataTable
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handler for changing number of rows per page
  const handlePerRowsChange = (newPerPage, page) => {
    let params = {};
    params.page = page;
    params.page_size = newPerPage;
    if (toolType?.id) {
      params.tool_type = toolType?.id
    }
    if (toolName?.id) {
      params.tools_name = toolName?.id
    }
    if (domain) {
      params.domain = domain?.id
    }
    if (consumptionType) {
      params.consumption_type = consumptionType?.id
    }
    if (statusWeb) {
      params.published_status_web_wap = statusWeb?.id == 'published' ? "True" : "False"
    }
    if (statusApp) {
      params.published_status_app = statusApp?.id == 'published' ? "published" : "unpublished"
    }
    dispatch(fetchPredictorToolsListingData(params))
    setPerPage(newPerPage);
  };
  const handleApply = () => {
    const params = {}
    // params.page = currentPage;
    // params.page_size = perPage;
    if (toolType?.id) {
      params.tool_type = toolType?.id
    }
    if (toolName?.id) {
      params.tools_name = toolName?.id
    }
    if (domain) {
      params.domain = domain?.id
    }
    if (consumptionType) {
      params.consumption_type = consumptionType?.id
    }
    if (statusWeb) {
      params.published_status_web_wap = statusWeb?.id == 'published' ? "True" : "False"
    }
    if (statusApp) {
      params.published_status_app = statusApp?.id == 'published' ? "published" : "unpublished"
    }

    if (Object.keys(params).length > 0) {
      dispatch(fetchPredictorToolsListingData(params))
    }
  }

  const handleClear = () => {
    setToolType(null),
      setToolName(null),
      setDomain(null),
      setConsumptionType(null),
      setStatusWeb(null),
      setStatusApp(null),
      setCurrentPage(1);
      window.location.reload();
  };


  const handleOnInputChangeFields = (type, value) => {
    let params = {};
    params[type] = value;
    let inDebounce = debounceState;
    if (type === "tools_name" && value) {
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        dispatch(getPredictorToolName({ field_name: "tools_name", q: value }))

      }, 1000);
      setDebounceState(inDebounce);
    }
  };

  return (
    <div>
      <h4>Manage Predictor Tools</h4>

      {/* Breadcrumb  */}
      <div className={'custom_breadcrumb'}>
        <ul className={'custom_breadcrumb_ul'}>
          <li className={'custom_breadcrumb_list'}>
            <Link to="/cms/">
              <a className={'sub_nan_anchor'}>Home</a>
            </Link>
          </li>
          <li className={'custom_breadcrumb_list'}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li
            className={`${'custom_breadcrumb_list'} ${'custom_breadcrumb_list_active'}`}
          >
            Manage Predictor Tools
          </li>
        </ul>
      </div>

      {/* Overview section  */}
      <div className={'overview'}>
        <div className={'country'}>
          <Row className="mb-4">
            <Col md={4}>
              <div className={'country_header'}>
                <h2>{totalPublishedRP}</h2>
                <h3>Total Published Result Predictor</h3>
              </div>
            </Col>
            {/* <Col md={4}>
              <div className={'country_header'}>
                <h2>68(Static)</h2>
                <h4>Total Published College Predictor</h4>
              </div>
            </Col> */}
          </Row>
        </div>
      </div>

      {/* Filter section  */}
      <div className={'examfilter'}>
        <Form>
          <h5 className="mb-4">Filter Predictor Tools</h5>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Search by Tool</Form.Label>
                <Select
                  name="tool_name"
                  value={toolName}
                  onChange={(obj) => {
                    setToolName(obj)
                  }}
                  onInputChange={(value) => {
                    handleOnInputChangeFields("tools_name", value);
                  }}
                  onFocus={() =>
                    dispatch(getPredictorToolName({ field_name: "tools_name" }))
                  }
                  options={predictorToolNameData?.tools_name || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={true}
                  placeholder={"Search By Tool"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Tool Type</Form.Label>
                <Select
                  name="tool_type"
                  value={toolType}
                  onChange={(obj) => {
                    setToolType(obj)
                  }}

                  options={predictorToolTypeData?.tools_type || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={false}
                  placeholder={"Select Tool Type"}

                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Domain</Form.Label>
                <Select
                  name="domain"
                  value={domain}
                  onChange={(obj) => {
                    setDomain(obj)
                  }}
                  options={predictorToolDomainData?.domain || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={false}
                  placeholder={"Search Domain"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Consumption Type</Form.Label>
                <Select
                  name="consumption_type"
                  value={consumptionType}
                  onChange={(obj) => {
                    setConsumptionType(obj)
                  }}
                  options={CONSUMPTION_TYPE || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={false}
                  placeholder={"Select Consumption Type"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Published Status Web/Wap</Form.Label>
                <Select
                  name="published_status_web_wap"
                  value={statusWeb}
                  onChange={(obj) => {
                    setStatusWeb(obj)
                  }}
                  options={PUBLISHED_STATUS_WEB_WAP || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={false}
                  placeholder={"Select Published Status Web/Wap"}

                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Published Status App</Form.Label>
                <Select
                  name="published_status_app"
                  value={statusApp}
                  onChange={(obj) => {
                    setStatusApp(obj)
                  }}
                  options={PUBLISHED_STATUS_APP || []}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.id}
                  isClearable={true}
                  isSearchable={false}
                  placeholder={"Select Status App"}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <div>
                  <br />
                  <button
                    className={'btnInfo'}
                    type="button"
                    onClick={handleApply}
                  >
                    Apply
                  </button>
                  <button
                    className={'btnInfo'}
                    type="button"
                    onClick={handleClear
                    }
                  >
                    Reset
                  </button>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>

      {/* Table section  */}
      <div className={'list_news_letters'}>
        <div className={'examfilter'}>
          <div className={'tablestrip'}>
            <div className={'tablestrip_left'}>
              <h4
                style={{
                  fontSize: '18px',
                  marginBottom: '0px',
                  paddingBottom: '0px',
                }}
              >
                List of Predictor Tools
              </h4>
            </div>
            {listingLoading ? (
              <Loading />
            ) : (
              <div className={'tablestrip_right'}>
                <ul className={'tablestrip_list'}>
                  <li className={'tablestrip_list_item'}>
                    <a href="/cms/tools/manage-predictor/basic-form" className={'tablestrip_list_anchor'}>
                      Create Tool
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>

          <div className='examfilter mt-4'>
            {listingLoading && <Loading />}
            {tableData && tableCustomData &&
              <DataTable
                columns={tableCustomData}
                data={tableData}
                progressPending={listingLoading}
                paginationTotalRows={totalRows}
                paginationPerPage={perPage}
                customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                pagination
                paginationServer
              />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManagePredictor